import { queryOptions } from '@tanstack/react-query'
import type { GuestMeetingPreview, GuestSessionResult } from '../model/schema'
import { fetchGuestMeeting, fetchGuestSession } from './access'

export const guestKeys = {
  all: ['guest'] as const,
  meeting: (token: string) => [...guestKeys.all, 'meeting', token] as const,
  session: () => [...guestKeys.all, 'session'] as const,
}

// Превью встречи для гостевого prejoin: гейт страницы /guest/$token —
// битая ссылка/ended/cancelled показываются до формы имени.
export function guestMeetingQueryOptions(token: string) {
  return queryOptions({
    queryKey: guestKeys.meeting(token),
    queryFn: (): Promise<GuestMeetingPreview> => fetchGuestMeeting(token),
  })
}

// Восстановление гостевого контекста из cookie. Всегда свежий снимок
// (staleTime 0): от него зависит маршрутизация гостя после refresh, кэш
// может отправить не туда.
export function guestSessionQueryOptions() {
  return queryOptions({
    queryKey: guestKeys.session(),
    queryFn: (): Promise<GuestSessionResult> => fetchGuestSession(),
    staleTime: 0,
    gcTime: 0,
  })
}
